export default "__VITE_ASSET__DWGAQbj4__"